const a = "image/jpeg, image/png, application/pdf, image/svg+xml, image/bmp, image/gif, image/tiff, image/eps, image/x-eps, image/photoshop, image/vnd.adobe.photoshop, image/vnd.microsoft.icon, image/psd, image/x-photoshop, image/x-psd, application/illustrator, application/x-photoshop, application/postscript", i = (e) => (s) => e.includes(s), n = (e) => (s) => s / 1024 / 1024 < e, d = ({
  type: e,
  size: s,
  maxFileSize: o,
  supportedExtensions: r
}) => {
  const t = n(o);
  return {
    type: {
      valid: i(
        r || a
      )(e),
      errorMsg: "invalid-file-type"
    },
    size: {
      valid: t(s),
      errorMsg: "invalid-file-size",
      value: o
    }
  };
};
var m = /* @__PURE__ */ ((e) => (e.Customer = "Customer", e.CustomerCare = "CustomerCare", e.PrePress = "PrePress", e.DirectApproval = "DirectApproval", e.APICustomer = "APICustomer", e))(m || {});
const l = {
  RemoveBackgroundFull: "Customers.API.DTOs.Shared.RemoveBackgroundFullInput, Customers.API",
  RemoveBackgroundOutsideImage: "Customers.API.DTOs.Shared.RemoveBackgroundOutsideImageInput, Customers.API",
  ReplaceColor: "Customers.API.DTOs.Shared.ReplaceColorInput, Customers.API",
  RemoveColor: "Customers.API.DTOs.Shared.RemoveColorInput, Customers.API",
  LaserConverter: "Customers.API.DTOs.Shared.LaserConverterInput, Customers.API",
  Crop: "Customers.API.DTOs.Shared.CropInput, Customers.API",
  EmbroideryConverter: "Customers.API.DTOs.Shared.EmbroideryConverterInput, Customers.API"
};
var u = /* @__PURE__ */ ((e) => (e.Lanyard = "Lanyard", e.RoundItem = "RoundItem", e.Regular = "Regular", e))(u || {});
const C = (e, s) => e * (s / 25.4), I = (e, s) => e / (s / 25.4);
export {
  m as ApproverType,
  u as Category,
  l as UserActionInputType,
  d as basicFileValidator,
  a as defaultSupportedExtensions,
  C as mm2px,
  I as px2mm
};
